<script setup lang="ts">
import type { TooltipEmits, TooltipProps, TooltipSlots } from '#ui/types';
import { reactiveOmit } from '@vueuse/core';
import { useForwardPropsEmits } from 'reka-ui';
import { computed } from 'vue';
import Tooltip from '#ui/components/Tooltip.vue';

const props = defineProps<TooltipProps>();
const emits = defineEmits<TooltipEmits>();
const slots = defineSlots<TooltipSlots>();

const forward = useForwardPropsEmits(reactiveOmit(props, 'kbds'), emits);
const kbds = computed<TooltipProps['kbds']>(() =>
	props.kbds?.map((kbd) => ({
		variant: 'solid',
		...(typeof kbd === 'string' ? { value: kbd } : kbd),
	})) as TooltipProps['kbds'],
);
</script>

<template>
	<Tooltip v-bind="forward" :kbds>
		<template v-for="(_, name) in slots" #[name]="slotData: any">
			<slot :name v-bind="slotData" />
		</template>
	</Tooltip>
</template>
